import { HttpUtil } from '../utils/http'
import { authenticate, refreshToken } from '@/auth/authHandler'
import UserService from '@services/user'

export const Actions = {
  isAdmin: async (context) => {
    if (context.state.isAdmin !== null) return
    const request = {
      Url: '/api/admin/isAdmin'
    }
    const res = await HttpUtil.Get(request)
    context.commit('isAdmin', { IsAdmin: res.data })
  },
  async authenticate (context) {
    let authorized = await authenticate()
    if (!authorized) {
      authorized = await refreshToken()
    }
    context.commit('setAuthentication', authorized)
    return authorized
  },
  resetAuthentication (context) {
    context.commit('resetAuthentication')
  },
  async setupFrontEndAppSettings (context) {
    const settings = context.state.settings
    if (!settings.initRun) {
      context.commit('setFrontEndAppSettings', await settings.init())
    }
  },
  async fetchUserHomeCountry (context) {
    await context.dispatch('pricing/getUserHomeCountry')
  },
  async fetchAllCountryCurrency (context) {
    await context.dispatch('pricing/getAllCountryCurrency')
  },
  async fetchDetailedUser () {
    return await UserService.getDetailedUser()
  },
  updateFrontEndAppSettings (context, settings) {
    context.commit('updateFrontEndAppSettings', settings)
  },
  detectBrowser (context) {
    let browser
    if (navigator.userAgent.indexOf('Opera') !== -1 || navigator.userAgent.indexOf('OPR') !== -1) browser = 'opera'
    else if (navigator.userAgent.indexOf('Edge') !== -1) browser = 'edge'
    else if (navigator.userAgent.indexOf('Chrome') !== -1) browser = 'chrome'
    else if (navigator.userAgent.indexOf('Safari') !== -1) browser = 'safari'
    else if (navigator.userAgent.indexOf('Firefox') !== -1) browser = 'firefox'
    else if ((navigator.userAgent.indexOf('MSIE') !== -1) || (!!document.documentMode === true)) browser = 'ie' // IF IE > 10
    context.commit('setBrowser', browser)
  },
  toggleSplashScreen (context, value) {
    context.commit('toggleSplashScreen', value)
  },
  setSplashScreenMessage (context, message) {
    context.commit('setSplashScreenMessage', message)
  },
  toggleSideNav (context, value) {
    context.commit('toggleSideNav', value)
  },
  addPromise ({ commit }, promiseUtilData) {
    commit('addPromise', promiseUtilData)
  },
  cacheRoute ({ commit }, route) {
    commit('cacheRoute', route)
  },
  clearCachedRoute ({ commit }) {
    commit('clearCachedRoute')
  }
}
